import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ExpenseStatuses = {
  PENDING: 0,
  APPROVED: 1,
  DENIED: 2,
  DRAFT: 4,
} as const

export type ExpenseStatusEnum = Enum<typeof ExpenseStatuses>
